import {RefObject} from 'react';
import {setRefs} from '../../commonSub/function';
import {CONTENT_CARD_THUMB_FIT_CN} from '../constant';
import {getPosterStyle, IPosterType} from '../hook/useAutoPlayVideo';
import useUserAgent from '../hook/useUserAgent';
import {VideoSource} from '../type';

interface IProps extends Omit<React.HTMLProps<HTMLVideoElement>, 'autoPlay'> {
  posterType: IPosterType;
  posterClassName?: string;
  videoRef: RefObject<HTMLVideoElement>;
  validSources?: VideoSource[];
  showImgPoster: boolean;
  isPosterOnly?: boolean;
  isBgSizeCover?: boolean;
}

export default function VideoWithPoster({
  poster,
  posterType,
  posterClassName,
  style,
  ref,
  videoRef,
  validSources,
  showImgPoster,
  isPosterOnly = false,
  isBgSizeCover = true,
  ...rest
}: IProps) {
  const userAgent = useUserAgent();
  return (
    <>
      <video
        style={getPosterStyle({posterType, poster, style, isBgSizeCover})}
        playsInline
        ref={el => setRefs(el, videoRef, ref)}
        {...rest}
        muted
        disableRemotePlayback
      >
        {!isPosterOnly &&
          validSources?.map(({src, type}) => (
            <source
              key={src}
              src={userAgent?.isFirefox ? src : undefined}
              data-src={src}
              type={type}
            />
          ))}
      </video>
      {showImgPoster && (
        <img
          src={poster}
          className={cn(CONTENT_CARD_THUMB_FIT_CN, posterClassName)}
          alt=""
        />
      )}
    </>
  );
}
